import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import CommonAction from '../../../Pages/Library/DPP/Library/TemplateComponent/CommonAction';
import { getControlStyle } from '../../helper';

export function Source(props) {
  const { t } = useTranslation('common');
  const reducer = useSelector((reducerstate) => reducerstate);
  const {
    otherConfiguration,
    fromForm,
    dataIndex,
    editingInput,
    deleteItem,
    relation,
    moduleName,
    values,
    selectedCombinationData,
    isAllCombination,
    dppAddEditAccess,
    isProductArchived,
  } = props;
  const combinedStyles = getControlStyle(otherConfiguration);
  const { SystemMastersDetails, DPPProductReducer } = reducer;
  const { dppProductDataById } = DPPProductReducer;
  const { productIdentifierList } = SystemMastersDetails;
  const checkToggel = (dppProductDataById?.sizeLengthToggel ?? true) && (dppProductDataById?.colorwayToggel ?? true);
  const renderProductidentifier = props?.fromProduct ? checkToggel : true;
  const showStyle = moduleName === 'productIdentifier' ? renderProductidentifier : true;

  const locationOption = [{ label: 'Product Identifier', value: 'productIdentifier' }];

  return (
    <div className="source-control">
      {!props?.fromProduct && relation && Object?.keys(relation)?.length === 0 && <p className="mb-2">Source</p>}
      {!relation?.location && (
        <div>
          <div className="empty-source">{t('DPP.CONTROL.SOURCE.EMPTY_DESCRIPTION')}</div>
        </div>
      )}

      <div className={otherConfiguration?.border && 'border-style'} style={showStyle ? combinedStyles : null}>
        <p className="f-14">
          {!props?.fromProduct && (
            <>
              <span>{relation?.location ? locationOption.filter((data) => data.value === relation?.location)?.map((re) => re?.label) : null}</span>
              {moduleName && ' > '}
            </>
          )}

          {moduleName === 'productIdentifier' && renderProductidentifier && (
            <span>
              {props?.fromProduct ? (
                (!props?.otherConfiguration || props?.otherConfiguration?.sourceSwitchTitle) && (
                  <>
                    <b>
                      {props?.otherConfiguration?.sourceMainTitle
                        ? props?.otherConfiguration?.sourceMainTitle
                        : productIdentifierList?.filter((datas) => datas?._id === relation?.subLocation)?.map((datas) => datas?.name)}
                    </b>
                    {' - '}
                  </>
                )
              ) : (
                <>
                  Value
                  {' > '}
                </>
              )}
              {props?.fromProduct && isAllCombination
                ? values
                    ?.filter(
                      (value) =>
                        value?.size === selectedCombinationData?.size &&
                        value?.length === selectedCombinationData?.length &&
                        value?.colour === selectedCombinationData?.colour,
                    )
                    ?.map((res) => res?.value)
                : productIdentifierList?.filter((datas) => datas?._id === relation?.subLocation)?.map((datas) => datas?.name)}
            </span>
          )}
        </p>
        {fromForm && (
          <CommonAction
            editingInput={editingInput}
            deleteItem={deleteItem}
            dataIndex={dataIndex}
            dppAddEditAccess={dppAddEditAccess}
            isProductArchived={isProductArchived}
          />
        )}
      </div>
    </div>
  );
}
export default Source;
